import { Space, Table, Spin, message, Popconfirm } from "antd";
import { useParams, Link, useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { get, deleteWithPayload } from "../../../services";
import { getDateHandler } from "../../../utils/dateHandler";
import { DeleteFilled, EditOutlined } from "@ant-design/icons";

const Usertable = () => {
  const { id } = useParams(); // This will get the 'id' from the URL
  /* Local States to save data */
  const navigate = useNavigate();
  const [userData, setUserData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [selectedRecord, setSelectedRecord] = useState(null);

  // confirm handler
  const confirm = (data, index) => {
    setSelectedRecord(index);
    console.log("index", index);
    // API call to delete selected record
    const payload = {
      startDate: data?.startDate,
      endDate: data?.endDate,
    };
    console.log("pay", payload);
    console.log("Dele", data);
    deleteWithPayload(`/hr/salary/${userData?.employee?._id}`, payload)
      .then(() => {
        // to delete locally from our frontend lists
        const remaingRecords = userData?.payPeriod?.filter(
          (item, sub) => sub !== index
        );
        setUserData({ ...userData, payPeriod: remaingRecords });
        // success message
        message.success("Record deleted Successfully");
        setSelectedRecord(false);
      })
      .catch(() => {
        message.error("Error");
        setSelectedRecord(false);
      });
  };

  // method for API call
  const getUserHandler = () => {
    setLoader(true);
    // axios call
    get(`/hr/salary/${id}`)
      .then((response) => {
        setUserData(response?.data);
        console.log(response);
        setLoader(false);
      })
      .catch((error) => {
        setLoader(false);
      });
  };

  //  API for user
  useEffect(() => {
    getUserHandler();
    // eslint-disable-next-line
  }, []);

  const columns = [
    {
      title: "id",
      dataIndex: "_id",
      key: "_id",
      render: (_, __, index) => <Space>{index + 1}</Space>,
    },
    {
      title: "Base Salary",
      dataIndex: "baseSalary",
      key: "baseSalary",
      render: (data) => (
        <div>
          <Space size="middle">{data}</Space>
        </div>
      ),
    },
    {
      title: "Allowances",
      dataIndex: "allowances",
      key: "allowances",
      render: (data) => <Space size="middle">{data}</Space>,
    },
    {
      title: "Deductions",
      dataIndex: "deductions",
      key: "deductions",
      render: (data) => <Space size="middle">{data}</Space>,
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
      render: (data) => <Space size="middle">{getDateHandler(data)}</Space>,
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
      render: (data) => <Space size="middle">{getDateHandler(data)}</Space>,
    },
    {
      title: "Action",
      key: "action",
      render: (data, __, index) => (
        <Space>
          <div className="flex">
            <div className="px-4">
              <EditOutlined
                className="cursor-pointer"
                onClick={() => {
                  navigate(`/edit-salary/${id}?key=${index}`);
                }}
              />
            </div>
            <div className="px-4">
              {index === selectedRecord ? (
                <Spin />
              ) : (
                <Popconfirm
                  title="Delete the task"
                  description="Are you sure to delete this task?"
                  onConfirm={() => confirm(data, index)}
                  okText="Yes"
                  cancelText="No"
                >
                  <DeleteFilled className="cursor-pointer" />
                </Popconfirm>
              )}
            </div>
          </div>
          {/* <Link to={`/salary-details/${data?._id}`}>Delete</Link>
          <Link to={`/edit-salary/${data?._id}`}>Edit</Link> */}
        </Space>
      ),
    },
  ];

  return (
    <div>
      <div className="header" style={{ paddingBottom: "15px" }}>
        <h3>Employee Salary Details</h3>
        <div className="events-button">
          <Link to="/add-salary">
            <button className="cursor-pointer add-event">
              Add Employee Salary
            </button>
          </Link>
        </div>
      </div>
      {/* table */}
      <div>
        <Table
          columns={columns}
          dataSource={userData?.payPeriod}
          loading={loader}
          pagination={false}
          scroll={{ x: 1023 }}
        />
      </div>
    </div>
  );
};
export default Usertable;
